import { createBlueprint as e } from "@made-people/blueprint";
const a = e({
  slots: {
    base: "",
    headingWrapper: "",
    body: "text-body-xs lg:text-body-sm leading-normal",
    truncateButton: "text-body-xs lg:text-heading-2xs after:content-[']'] after:absolute before:content-['[']  before:absolute hover:before:-translate-x-2 hover:after:translate-x-1 before:-translate-x-1.5 after:translate-x-0.5 pl-1 after:transition-transform before:transition-transform w-fit",
    ctaWrapper: "flex flex-wrap gap-2",
    // Markdown Slots
    ul: "list-[disc] pl-8",
    ol: "list-[decimal-leading-zero] pl-8",
    li: "",
    span: "",
    p: "",
    h1: "",
    h2: "",
    h3: "",
    h4: "",
    h5: "",
    h6: "",
    blockquote: "",
    hr: "",
    a: "",
    strong: "",
    em: "",
    code: "",
    img: "",
    table: "",
    thead: "",
    tbody: "",
    tr: "",
    th: "",
    td: "",
    pre: ""
  },
  variants: {
    spacing: {
      true: {
        base: "max-w-[750px]"
      },
      false: {
        base: ""
      }
    },
    alignment: {
      left: {
        base: "text-left"
      },
      centered: {
        base: "text-center"
      }
    },
    layout: {
      none: {
        base: "",
        headingWrapper: "",
        body: "",
        truncateButton: ""
      },
      vertical: {
        base: "flex flex-col gap-3 items-start",
        body: "",
        ctaWrapper: "mt-3"
      },
      twoColumn: {
        base: "max-w-none w-full grid grid-cols-12 grid-rows-[auto_auto_auto] gap-x-3 lg:gap-x-6 items-start",
        headingWrapper: "col-start-1 col-end-4 capitalize text-left row-start-2 row-end-4 mb-0",
        body: "col-start-4 col-end-13 row-start-2 row-end-3 text-left mb-0",
        truncateButton: "col-start-4 col-end-13 justify-self-start row-start-3 row-end-4 mt-4 capitalize no-underline",
        ctaWrapper: "flex flex-row gap-4 col-start-5 col-end-13 row-start-3 row-end-4 mt-4"
      },
      centered: {
        base: "flex flex-col gap-4 items-center max-w-[750px]",
        headingWrapper: "text-center max-w-[400px]",
        body: "text-center",
        ctaWrapper: "justify-self-center flex flex-row gap-2 mt-4"
      }
    }
  },
  defaultVariants: {
    spacing: "true",
    layout: {
      initial: "vertical",
      lg: "vertical"
    }
  }
}), r = e({
  slots: {
    wrapper: ""
  },
  variants: {
    lines: {
      none: {
        wrapper: ""
      },
      1: {
        wrapper: "line-clamp-1"
      },
      2: {
        wrapper: "line-clamp-2"
      },
      3: {
        wrapper: "line-clamp-3"
      },
      4: {
        wrapper: "line-clamp-4"
      },
      5: {
        wrapper: "line-clamp-5"
      },
      6: {
        wrapper: "line-clamp-6"
      }
    }
  }
});
export {
  a as textBlockBlueprint,
  r as truncateVariants
};
//# sourceMappingURL=index-blueprint.es.js.map
